// Angular Files
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular Material Files
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';

// Teller Online Library Files
import { PipesModule } from '../../pipes/pipes.module';

// Component Files
import { TellerOnlineScheduleDetailsComponent } from './schedule-details.component';

@NgModule({
    declarations: [TellerOnlineScheduleDetailsComponent],
    imports: [
        CommonModule,
        MatTableModule,
        MatListModule,
        PipesModule
    ],
    exports: [TellerOnlineScheduleDetailsComponent]
})
export class TellerOnlineScheduleDetailsModule {}
